import { render, staticRenderFns } from "./UpdateAFS.vue?vue&type=template&id=515d31dc&scoped=true"
import script from "./UpdateAFS.vue?vue&type=script&lang=js"
export * from "./UpdateAFS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d31dc",
  null
  
)

export default component.exports